module.exports = __webpack_public_path__ + "static/media/marker.078b38f4.svg";